<template>
  <div>
    <h1 class="title has-text-centered is-spaced">
      <go-to-dashboard-button />
      {{ $t("productChangeLogs.title") }}
      <button class="button action-button" @click="$emit('search')">
        <b-icon icon="sync-alt" />
      </button>
      <button
        class="button action-button"
        :title="$t('productChangeLogs.downloadReport')"
        :aria-label="$t('productChangeLogs.downloadReport')"
        @click="$emit('download')"
      >
        <b-icon icon="save" />
      </button>

      <button
        v-if="hasSelectedFilters"
        type="button"
        class="button action-button clear-filters-button"
        :title="$t('productChangeLogs.clearFilters')"
        :aria-label="$t('productChangeLogs.clearFilters')"
        @click="clearFilters"
      >
        <b-icon icon="times-circle" />
        <span>{{ $t("productChangeLogs.clearFilters") }}</span>
      </button>
    </h1>

    <div class="columns">
      <div class="column is-3">
        <b-field :label="$t('common.store')" label-position="on-border">
          <b-select
            v-model="storeId"
            expanded
            @input="$emit('update-store', storeId)"
          >
            <option value="">{{ $t("productChangeLogs.allStores") }}</option>
            <option v-for="store in stores" :key="store._id" :value="store._id">
              {{ store.storeInfo.name }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-3">
        <b-field
          :label="$t('productChangeLogs.period')"
          label-position="on-border"
        >
          <b-datepicker
            v-model="dates"
            range
            expanded
            :placeholder="$t('productChangeLogs.selectPeriod')"
            :mobile-native="false"
            @input="$emit('update-dates', dates)"
          />
        </b-field>
      </div>

      <div class="column is-3">
        <b-field
          :label="$t('productChangeLogs.field')"
          label-position="on-border"
        >
          <b-select
            v-model="field"
            expanded
            @input="$emit('update-field', field)"
          >
            <option value="">{{ $t("productChangeLogs.allFields") }}</option>
            <option
              v-for="option in fieldOptions"
              :key="option"
              :value="option"
            >
              {{ $t(`productChangeLogs.fields.${option}`) }}
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-3">
        <b-field
          :label="$t('productChangeLogs.search')"
          label-position="on-border"
        >
          <!-- Diferente dos outros filtros, a busca só consulta ao confirmar,
               para não disparar uma requisição por caractere digitado. -->
          <b-tooltip
            multilined
            position="is-bottom"
            :triggers="['hover', 'focus']"
            :label="$t('productChangeLogs.searchHint')"
            class="search-tooltip"
          >
            <b-input
              v-model.trim="search"
              expanded
              icon-right="search"
              icon-right-clickable
              :placeholder="$t('productChangeLogs.searchPlaceholder')"
              @input="$emit('update-search', search)"
              @icon-right-click="$emit('search')"
              @keyup.native.enter="$emit('search')"
            />
          </b-tooltip>
        </b-field>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import goToDashboardButton from "../common/GoToDashboardButton";
import { PRODUCT_CHANGE_FIELDS } from "../../utils/productChangeLogs";

export default {
  components: { goToDashboardButton },

  data() {
    return {
      storeId: "",
      dates: [],
      field: "",
      search: "",
      fieldOptions: PRODUCT_CHANGE_FIELDS
    };
  },

  methods: {
    // Os filtros vivem neste componente, então ele mesmo se limpa e avisa o
    // painel uma única vez, em vez de emitir uma atualização por campo.
    clearFilters() {
      this.storeId = "";
      this.dates = [];
      this.field = "";
      this.search = "";

      this.$emit("clear-filters");
    }
  },

  computed: {
    ...mapGetters(["stores"]),

    hasSelectedFilters() {
      return Boolean(
        this.storeId || this.field || this.search || this.dates.length
      );
    }
  }
};
</script>

<style scoped>
.action-button {
  margin-left: 0.5rem;
}
/* O rótulo herda o tamanho do título se não for reduzido aqui. */
.clear-filters-button {
  font-size: 1rem;
  border-color: hsl(348, 86%, 61%);
  color: hsl(348, 86%, 40%);
  font-weight: 700;
  box-shadow: 0 0 0 1px hsla(348, 86%, 61%, 0.25);
}
.clear-filters-button:hover,
.clear-filters-button:focus {
  background-color: hsl(348, 100%, 95%);
  border-color: hsl(348, 86%, 50%);
  color: hsl(348, 86%, 35%);
}
.clear-filters-button span:not(.icon) {
  margin-left: 0.35rem;
}
/* O tooltip envolve o campo, então precisa ocupar a largura da coluna. */
.search-tooltip {
  width: 100%;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
